import React from "react";
import { useSelector } from "react-redux";
import { IReduxAppState } from "../../reducers";

interface IDisableComponent {
    children: JSX.Element;
    disabledPermissions: Record<string, string[]>;
}


/**Component wrapper which disables components based on subscription */
export function DisableComponents({
    children,
    disabledPermissions
}: IDisableComponent) {
    const subscription = useSelector((state: IReduxAppState) => state.subscription);

    if (disabledPermissions && disabledPermissions[subscription]) {
        const perms = disabledPermissions[subscription];

        if (perms && Array.isArray(perms)) {
            if (perms.length === 0) {
                return null;
            } else if (perms.indexOf("Write") > -1) {
                return React.cloneElement(children, { disabled: true });
            }
        }
    }

    return children;
}